import { getIntegrationResource } from "api/integrationResources";
import constate from "constate";
import { Map } from "immutable";
import { type IntegrationResourceModel } from "models/IntegrationResourceModel";
import { useCallback, useState } from "react";

const useAccessReportResources = () => {
  const [integrationResources, setIntegrationResources] = useState(Map<string, IntegrationResourceModel>());

  const fetchIntegrationResource = useCallback(async (id: string): Promise<IntegrationResourceModel | undefined> => {
    if (!id) return undefined;
    const integrationResource = await getIntegrationResource(id);
    if (integrationResource) setIntegrationResources((current) => current.set(id, integrationResource));
    return integrationResource;
  }, []);

  return {
    actions: {
      fetchIntegrationResource,
    },
    state: { integrationResources },
  };
};

export const [AccessReportResourcesProvider, useAccessReportResourcesContext] = constate(useAccessReportResources);
